import { toValidDate } from "@/lib/safeDate";

/**
 * Value stored on tasks.due_date.
 * Omitted stays omitted. Empty, blank, and unreadable become null.
 * A real value is kept as the caller wrote it, so a date-only postpone is unchanged.
 */
export function taskDueDateToPersist(
  value: unknown,
): string | null | undefined {
  if (value === undefined) return undefined;
  if (value === null) return null;
  if (typeof value === "string") {
    if (value.trim() === "") return null;
    return toValidDate(value) ? value : null;
  }
  if (value instanceof Date) {
    return toValidDate(value) ? value.toISOString() : null;
  }
  return null;
}

export function withPersistedTaskDueDate<T extends Record<string, unknown>>(
  data: T,
): T {
  if (!("due_date" in data)) return data;
  return { ...data, due_date: taskDueDateToPersist(data.due_date) };
}
